import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { api } from './api';
import { queryKeys } from './queryClient';
import type { SearchResults } from '../types';

export const MIN_SEARCH_LENGTH = 2;
export const MAX_SEARCH_LENGTH = 200;

/**
 * Global search (#27). The previous results stay on screen while the next ones load. Runs only while the box
 * is open and never counts as fresh, so reopening it asks again: a contract archived or a document deleted
 * since must not stay in a result the person can open.
 */
export const useGlobalSearch = (query: string, open: boolean) => {
  return useQuery({
    queryKey: queryKeys.search.results(query),
    queryFn: ({ signal }) => api.get<SearchResults>('/search', { params: { q: query }, signal }),
    enabled: open && query.length >= MIN_SEARCH_LENGTH,
    placeholderData: keepPreviousData,
    staleTime: 0,
    retry: false,
  });
};
